<template>
  <div class="sd">
    <div class="index-2">
      <el-carousel
        :interval="5000"
        indicator-position="none"
        arrow="always"
        height="600px"
      >
        <el-carousel-item v-for="(item, i) in slideData" :key="i">
          <img :src="item.image" alt="" />
          <el-row type="flex" class="row-bg tips">
            <el-col :span="6">
              <div v-if="item.described" class="grid-content bg-purple">
                <div class="index-3">
                  <span>{{ item.described }} </span>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light index-4">
                {{ item.title }}
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
      <!-- <el-row type="flex" class="row-bg tips">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="index-3">
              <span
                >10年以上地产经验资深团队专为
                <br />职业房东和房地产经纪人倾情打造
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light index-4">职业房东</div>
        </el-col>
      </el-row> -->
      <el-row type="flex" class="row-bg search">
        <el-col :span="16">
          <el-input
            class="serach_input"
            v-model="keyword"
            placeholder="请输入路名/小区/地铁/房屋特性..."
          ></el-input>
        </el-col>
        <el-col :span="8">
          <el-button
            class="serach_btn"
            type="primary"
            icon="el-icon-search"
            @click="tokeywordsearch(keyword)"
            >搜索房源
          </el-button>
        </el-col>
      </el-row>
      <!-- <div class="index-1">
        <el-row type="flex" class="row-bg" style="margin-top: 243px">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="index-3">
                <span
                  >10年以上地产经验资深团队专为
                  <br />职业房东和房地产经纪人倾情打造
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light index-4">职业房东</div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" style="margin-top: 20px">
          <el-col :span="16">
            <el-input
              class="serach_input"
              v-model="keyword"
              placeholder="请输入路名/小区/地铁/房屋特性..."
            ></el-input>
          </el-col>
          <el-col :span="8">
            <el-button
              class="serach_btn"
              type="primary"
              icon="el-icon-search"
              @click="tokeywordsearch(keyword)"
              >搜索房源
            </el-button>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <!-- 区域找房 -->
    <div v-if="houseData.length > 0">
      <el-row type="flex" class="container row-bg">
        <el-col :span="24">
          <div class="index-5">
            <img src="../assets/images/relax.png" class="index-6copy" alt="" />
            <span class="index-7">最新房源</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="container row-bg">
        <el-col :span="24" class="more">
          <div>
            <span @click="tohouselist()">查看更多</span>
          </div>
        </el-col>
      </el-row>
      <section class="section">
        <div class="container">
          <div class="row lightcasestudies">
            <div
              class="col-md-4"
              v-for="todo in houseData"
              style="cursor: pointer"
            >
              <div class="case-box" @click="tohouseDetail(todo.id)">
                <img
                  v-if="todo.imgurl"
                  :src="todo.imgurl"
                  alt=""
                  style="height: 237px; width: 100%; object-fit: cover"
                  class="img-responsive"
                />
                <img
                  class="noimg"
                  style="height: 237px; width: 100%; object-fit: cover"
                  v-else
                  src="../assets/images/zhiyeminicode.png"
                  alt="../assets/images/zhiyeminicode.png"
                />
                <div v-if="!todo.imgurl" class="noimg-tips">图片拍摄中</div>
                <p class="kucun" v-if="todo.is_past_due == 1">库存盘</p>
                <span class="tips" v-if="todo.type == 1">个人</span>
                <span class="tips" v-else-if="todo.type == 2">秒租</span>
                <span class="tips" v-else-if="todo.type == 3">私盘</span>
                <span class="tips" v-else-if="todo.type == 4">二房东</span>
                <div class="case-info clearfix">
                  <div class="index-16">
                    <h4 class="index-17">
                      {{ todo.village_name }}{{ todo.building_no }}号{{
                        todo.room_no
                      }}室
                    </h4>
                    <h5 style="text-align: left">
                      {{ todo.room }} 室 {{ todo.hall }} 厅
                      {{ todo.bathrooms }} 卫
                    </h5>
                    <div class="index-18">
                      <h5 style="text-align: left">
                        <span style="color: red">{{ todo.commission }}</span
                        >%佣金
                      </h5>
                      <h5 class="index-10">
                        <span class="index-11">¥</span>
                        <span class="index-11">{{ todo.rental }}</span>
                      </h5>
                    </div>
                  </div>
                  <!-- <div class="pull-right">
                 
                  <h5 class="index-10"><span class="index-11">¥</span><span class="index-11">{{todo.rental}}</span></h5>
                 
                </div>-->
                </div>
                <!-- end case-info -->
              </div>
              <!-- end case-box -->
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
          <!-- <div class="row">
          <div class="col-md-12 index-14">
            <span class="index-13" @click="tohouselist()">查看更多</span>
          </div>
        </div> -->
        </div>
        <!-- end container -->
      </section>
    </div>

    <!-- 热门房源 -->
    <div v-if="hotHouseData.length > 0">
      <el-row type="flex" class="container row-bg">
        <el-col :span="24">
          <div class="index-5">
            <img src="../assets/images/relax.png" class="index-6copy" alt="" />
            <span class="index-7">热门公寓</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="container row-bg">
        <el-col :span="24" class="more">
          <div>
            <span @click="toHouseListSearch()">查看更多</span>
          </div>
        </el-col>
      </el-row>
      <section class="section">
        <div class="container">
          <template>
            <el-carousel :interval="4000" type="card" height="270px">
              <el-carousel-item v-for="(todo, i) in hotHouseData" :key="i">
                <div class="items" @click="tohouseDetail(todo.id)">
                  <img :src="todo.imgurl" class="img-cover" alt="" />
                  <span class="rec_village_name"
                    >{{ todo.village_name }}{{ todo.building_no }}号{{
                      todo.room_no
                    }}室</span
                  >
                </div>
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
      </section>
    </div>

    <!-- 区域找房 -->
    <!-- <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <div class="index-5">
          <img src="../assets/images/fdjicon.svg" class="index-6" alt="" />
          <span class="index-7">区域找房</span>
        </div>
      </el-col>
    </el-row>
    <section class="probootstrap-section">
      <div class="container" style="padding-bottom: 84px">
        <div class="row" style="margin-top: 63px">
          <div
            class="col-lg-3 col-md-4 col-sm-6 col-xs-12 probootstrap-animate"
            data-animate-effect="fadeIn"
            v-for="todod in quyuData"
            style="cursor: pointer"
          >
            <div class="image-popup" @click="toquyusearch(todod.areaid)">
              <img
                src="../assets/images/shanghaione.jpg"
                class="img-responsive img-rounded"
                alt="Free Bootstrap Template by uicookies.com"
              />
              <span class="index-15">{{ todod.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 小程序 -->
    <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <div class="index-5one">
          <img
            src="../assets/images/minichatone.svg"
            class="index-6one"
            alt=""
          />
          <span class="index-7">小程序</span>
        </div>
      </el-col>
    </el-row>

    <section>
      <div style="padding-bottom: 110px">
        <div style="" class="index-minip">
          <img
            src="../assets/images/miniprogram.jpg"
            class="index-9one"
            alt=""
          />
          <span class="indexteone"
            >微信扫码关注职业房东网小程序，享受更多便捷功能</span
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { cosh } from "core-js/core/number";
import https from "../http.js";
import { getLoaction } from "../location.js";
import qs from "qs";

export default {
  data() {
    return {
      houseData: [],
      hotHouseData: [],
      quyuData: [],
      slideData: [],
      today_views: "",
      keyword: "",
    };
  },

  created: function() {
    if (this._isMobile()) {
      var isWeiXin = this._isWeiXin();
      if (isWeiXin) {
        this.$router.replace("/MiniIndex");
      } else {
        this.$router.replace("/IndexPhone");
      }
    } else {
      this.$router.replace("/Index");
    }
    var userid = this.$cookies.get("userid");
    if (userid == null) {
      userid = 0;
    }
    getLoaction.getLocationAddress().then((locationData) => {
      var param = {
        user_id: userid,
        province: locationData.ad_info.province,
        city: locationData.ad_info.city,
      };
      https
        .fetchPost("/index/index", qs.stringify(param))
        .then((data) => {
          console.log(data);
          this.houseData = data.data.today_house;
          this.hotHouseData = data.data.hot_house;
          this.quyuData = data.data.area;
          this.slideData = data.data.slide_data;
          this.today_views = data.data.today_views;
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  methods: {
    tohouseDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/HouseDetail",
        query: { houseid: id },
      });
      window.open(routeUrl.href, "_blank");
    },

    toquyusearch(areaid) {
      this.$router.push({ path: "/HouseList", query: { areaid: areaid } });
    },

    tokeywordsearch(keyword) {
      this.$router.push({ path: "/HouseList", query: { keyword: keyword } });
    },

    toHouseListSearch() {
      this.$router.push({ path: "/HouseList", query: { houseType: "4,5" } });
      window.scrollTo(0, 0);
    },

    tohouselist() {
      this.$router.push({ path: "/HouseList" });
      window.scrollTo(0, 0);
    },

    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    _isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf("micromessenger") > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
  },
};
</script>
<style src="../assets/css/bootstrap.min.css" scoped></style>

<style scoped>
.kucun {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  letter-spacing: 4px;
  z-index: 999;
}
.sd {
  background-color: #f2f2f2;
}
.case-box .tips {
  display: block;
  padding: 2px 12px;
  background: #ff7ca7;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  color: #fff;
}
.case-box .tips:after {
  content: "";
  width: 0px;
  height: 0px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #ff7ca7;
  position: absolute;
  top: 0;
  right: -10px;
}
.case-box .tips::before {
  content: "";
  position: absolute;
  display: block;
  width: 5px;
  height: 5px;
  border: 2px solid #fff;
  border-radius: 50%;
  top: 8px;
  right: 1px;
}
.index-1 {
  /* background: url(../assets/images/01.png) no-repeat center center; */
  height: 621px;
  width: 100%;
}

.index-fan {
  text-align: right;
  margin-right: 93px;
  margin-top: 87px;
}

.index-minip {
  width: 1123px;
  height: 194px;
  padding-top: 42px;
  background: url(../assets/images/miniprobac.jpg) no-repeat center center;
  margin: 0 auto;
}

.index-fan1 {
  background: #000;
  color: #fff;
  padding: 8px;
}

.index-2 {
  display: flex;
  flex-direction: column;
  position: relative;
}

.index-3 {
  width: 126px;
  height: 294px;
  margin: -45px 113px;
  background: rgba(0, 0, 0, 1);
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-lr;
  color: #fff;
  font-size: 17px;
  display: flex;
  align-items: center;
}
.index-3 span {
  padding-top: 16px;
  padding-bottom: 16px;
}
.index-4 {
  color: #fff;
  font-size: 4em;
}
.index-5,
.index-5one {
  margin-top: 30px;
}
.index-6 {
  width: 88px;
  padding: 5px 25px;
  display: inline-block;
  margin: -23px;
}

.index-5one {
  margin-bottom: 50px;
}
.index-6one {
  width: 94px;
  padding: 5px 25px;
  display: inline-block;
  margin: -23px;
}

.index-9one {
  width: 103px;
  margin-left: -19px;
}

.indexteone {
  color: #fff;
  background: #000;
  padding: 7px;
  margin-left: 21px;
}

.index-6copy {
  width: 104px;
  padding: 5px 25px;
  display: inline-block;
  margin: -23px;
}
.index-7 {
  border-left: 4px solid #000;
  padding: 8px 15px;
  display: inline-block;
  margin: 10px;
  font-size: 1.8em;
}
.index-8 {
  display: flex;
  flex-direction: row;
}

.index-10 {
  text-align: left;
}

.index-11 {
  font-size: 20px;
  color: rgb(15, 124, 226);
}

.index-13 {
  background: #000;
  padding: 12px 20px;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.index-14 {
  margin-top: 35px;
  margin-bottom: 40px;
}

.index-15 {
  margin-top: -117px;
  position: absolute;
  margin-left: -22px;
  color: #fff;
  font-size: 27px;
}

/* 今日房源 */
.case-box:hover .magnifier {
  opacity: 0.8;
  filter: alpha(opacity=80);
  /* For IE8 and earlier */
  left: 0;
}

.case-box h4 {
  color: #ffffff;
  padding: 16px 0 0;
  margin: 0;
}

.case-link {
  width: 40px;
  display: block;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  border-radius: 4px;
  height: 40px;
  line-height: 39px;
  margin: 17px 0 0;
  position: absolute;
  right: 5px;
}

.case-box:hover .case-link {
  border-color: #fff;
}

.case-box:hover .case-link a {
  color: #ffffff !important;
}

.case-box small {
  font-style: italic;
  color: rgba(255, 255, 255, 0.8);
}

.lightcasestudies .col-md-4 {
  margin: 15px 0;
}

.lightcasestudies .case-box {
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ededed;
  position: relative;
  box-shadow: 0px 5px 35px 0px rgba(148, 146, 245, 0.15);
}

.lightcasestudies .case-box h4 {
  color: #232323;
}

.lightcasestudies .case-box small {
  color: #787878;
}

.case-info {
  position: relative;
  padding: 0 10px;
}

.lightcasestudies .case-link {
  background-color: #fff;
  border-color: #eee;
}

.lightcasestudies .case-box:hover {
  border: 1px solid #ededed;
  background: #ffffff !important;
}

/* 今日房源 */

.image-popup {
  margin-bottom: 30px;
  float: left;
  width: 100%;
}

.index-16 {
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
}

.index-17 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 264px;
  text-align: left;
}

.index-18 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.serach_input {
  width: 600px;
  float: right;
}

.serach_input /deep/ .el-input__inner {
  height: 55px;
  font-size: 18px;
  border-radius: inherit;
}

.serach_btn {
  float: left;
  height: 55px;
  color: #fff;
  font-size: 18px;
  border-radius: inherit;
}
.more {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.more span {
  color: #333;
  font-size: 17px;
  text-decoration: underline;
  cursor: pointer;
}
.items {
  position: relative;
  height: 300px;
}
.items .img-cover {
  width: 100%;
  height: 100%;
}
.items .rec_village_name {
  position: absolute;
  height: 50px;
  line-height: 50px;
  bottom: 30px;
  left: 0px;
  width: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.index-2 .el-carousel,
.index-2 .el-carousel__container {
  width: 100%;
}
.index-2 .el-carousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.noimg-tips {
  text-align: center;
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  background: rgba(45, 45, 45, 0.7);
  color: #fff;
  font-weight: 500;
  height: 237px;
  width: 100%;
  line-height: 237px;
  font-size: 28px;
}
</style>
<style>
.index-2 .search {
  width: 100%;
  z-index: 5;
  top: 500px !important;
  position: absolute;
}
.index-2 .tips {
  position: absolute;
  width: 100%;
  z-index: 5;
  top: 180px;
}
.index-2 .el-carousel__arrow--left,
.index-2 .el-carousel__arrow--right {
  right: 16px;
  width: 40px;
  height: 120px;
  border-radius: 5px;
  font-size: 40px;
  font-weight: 900;
  background-color: rgba(31, 45, 61, 0.4);
}
</style>
